import $ from 'jquery';

function connect() {
	let $connect				= $('.c-connect-bar'),
			$container  		= $('.c-connect-bar_main'),
			$button    			= $('.c-connect-bar_form-toggle'),
			$mainClose 			= $('.c-connect-bar_close'),
			$prev      			= $('.c-connect-bar_prev'),
			$offCanvas  		= $('.c-off-canvas'),
			$menuToggle 		= $('.c-off-canvas a[href="#connect"]'),
			$connectToggle 	= $('.c-connect-bar_toggle-button');

	// Toggle correct form
	$button.click(function() {
		let $type = $(this).data('toggle'),
				$hide = $(this).data('hide');
		
		$prev.addClass('is-visible');
		$(`.c-connect-bar_${$type}, .c-connect-bar_${$type}-form, .c-connect-bar_content`).addClass('form-is-active');
		$(`.c-connect-bar_${$hide}`).addClass('hide');
	});

	// Reset function on close
	$mainClose.click(function() {
		reset();
	});

	// Reset function on prev
	$prev.click(function() {
		reset();
	})

	// Toggle the connect bar slide up when nav item with #connect is clicked ( mobile )
	$menuToggle.click(function() {
		$offCanvas.foundation('toggle', event);
		setTimeout(function() {
			$container.foundation('toggle');
		}, 300);
	});

	// Add 'is-expanded' class to main container when bottom bar is expanded
	// Cant use generic toggler on a sticky component ( foundation bug? )
	$container.on('on.zf.toggler', function() {
		$connect.addClass('is-expanded');
		$container.attr('aria-hidden', 'false');
	}).on('off.zf.toggler', function() {
		$connect.removeClass('is-expanded');
		$container.attr('aria-hidden', 'true');
	})

	// Reset the connect bar to the original state
	function reset() {
		$prev.removeClass('is-visible');
		$('.c-connect-bar_corporate, .c-connect-bar_consumer, .c-connect-bar_freight, .c-connect-bar_forms, .c-connect-bar_content').removeClass('form-is-active hide');
	}

	$connectToggle.click(function() {
		const footerTop 		= $("#footer").offset().top,
					windowHeight 	= $(window).height();

		// Check to make sure user is at the bottom of the page
		if($(window).scrollTop() + $(window).height() == $(document).height()) {
			$("html, body").animate({
				scrollTop: footerTop - windowHeight
			 }, 300);
		}
	});
}

export { connect };